var WebSessionStorage = /** @class */ (function () {
    function WebSessionStorage(category, storage) {
        if (storage === void 0) { storage = sessionStorage; }
        this.category = category;
        this.storage = storage;
    }
    WebSessionStorage.prototype.getKey = function () {
        return this.category;
    };
    WebSessionStorage.prototype.clear = function () {
        var storageKey = this.getKey();
        this.storage.removeItem(storageKey);
    };
    WebSessionStorage.prototype.getAll = function () {
        var storageKey = this.getKey();
        var storage = this.storage.getItem(storageKey);
        if (!storage) {
            return {};
        }
        return JSON.parse(storage);
    };
    WebSessionStorage.prototype.getItem = function (key) {
        var storage = this.getAll();
        return storage[key];
    };
    WebSessionStorage.prototype.setItem = function (key, value) {
        var storageKey = this.getKey();
        var storage = this.getAll();
        storage[key] = value;
        this.storage.setItem(storageKey, JSON.stringify(storage));
    };
    WebSessionStorage.prototype.setRaw = function (state) {
        var storageKey = this.getKey();
        this.storage.setItem(storageKey, JSON.stringify(state));
    };
    WebSessionStorage.prototype.removeItem = function (key) {
        var storageKey = this.getKey();
        var storage = this.getAll();
        delete storage[key];
        this.storage.setItem(storageKey, JSON.stringify(storage));
    };
    return WebSessionStorage;
}());
export { WebSessionStorage };
//# sourceMappingURL=WebSessionStorage.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/data/WebSessionStorage.js
// module id = 39
// module chunks = 1